import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqCheckboxComponent } from './components/datiq-checkbox';
import { DatiqSwitchComponent } from './components/datiq-switch';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { DatiqCheckboxToggleComponent } from './components/datiq-checkbox-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';

const components = [DatiqCheckboxComponent, DatiqSwitchComponent, DatiqCheckboxToggleComponent];

@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [
        CommonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatRadioModule,
        MatIconModule,
        MatButtonToggleModule
    ],
})
export class DatiqCheckboxModule {}
